module.exports = __webpack_public_path__ + "img/y-139.6acb1597.png";